function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

// class QuantityInput extends HTMLElement {
//   constructor() {
//     super();
//     this.input = this.querySelector('input');
//     this.changeEvent = new Event('change', { bubbles: true });

//     this.input.addEventListener('change', this.onInputChange.bind(this));
//     this.querySelectorAll('button').forEach((button) =>
//       button.addEventListener('click', this.onButtonClick.bind(this))
//     );
//   }

//   quantityUpdateUnsubscriber = undefined;

//   connectedCallback() {
//     this.validateQtyRules();
//     // this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));

//     // newwww
//     connectedCallback() {
//       this.validateQtyRules();

//       this.quantityUpdateUnsubscriber = subscribe(
//         PUB_SUB_EVENTS.quantityUpdate,
//         this.validateQtyRules.bind(this)
//       );

//       this.variantChangeUnsubscriber = subscribe(
//         PUB_SUB_EVENTS.variantChange,
//         this.onVariantChange.bind(this)
//       );
//     }
//   }

//   disconnectedCallback() {
//     if (this.quantityUpdateUnsubscriber) {
//       this.quantityUpdateUnsubscriber();
//     }
//   }

//   // onInputChange(event) {
//   //   this.validateQtyRules();
//   // }

//     // newww
//   onInputChange() {
//     this.validateQtyRules();

//     const formId = this.input.getAttribute('form');
//     const productForm = formId
//       ? document.getElementById(formId)
//       : null;

//     const submittedQuantity = productForm?.querySelector(
//       '.product-submit-quantity'
//     );

//     if (submittedQuantity) {
//       submittedQuantity.value = this.input.value;
//       console.log('Form quantity updated:', submittedQuantity.value);
//     }
//   }

//   onButtonClick(event) {
//     event.preventDefault();
//     const previousValue = this.input.value;

//     event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
//     if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
//   }

//   validateQtyRules() {
//     const value = parseInt(this.input.value);
//     if (this.input.min) {
//       const min = parseInt(this.input.min);
//       const buttonMinus = this.querySelector(".quantity__button[name='minus']");
//       buttonMinus.classList.toggle('disabled', value <= min);
//     }
//     if (this.input.max) {
//       const max = parseInt(this.input.max);
//       const buttonPlus = this.querySelector(".quantity__button[name='plus']");
//       buttonPlus.classList.toggle('disabled', value >= max);
//     }
//   }
// }


class QuantityInput extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener(
      'change',
      this.onInputChange.bind(this)
    );

    this.querySelectorAll('button').forEach((button) => {
      button.addEventListener(
        'click',
        this.onButtonClick.bind(this)
      );
    });
  }

  quantityUpdateUnsubscriber = undefined;
  variantChangeUnsubscriber = undefined;

  connectedCallback() {
    this.normalizeQuantityValue();
    this.validateQtyRules();
    this.updateProductFormQuantity();

    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );

    this.variantChangeUnsubscriber = subscribe(
      PUB_SUB_EVENTS.variantChange,
      this.onVariantChange.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }

    if (this.variantChangeUnsubscriber) {
      this.variantChangeUnsubscriber();
    }
  }

  onVariantChange(event) {
    const newHtml = event?.data?.html;

    if (!newHtml) return;

    const newQuantityInput = newHtml.getElementById(this.input.id);

    if (!newQuantityInput) return;

    const attributesToUpdate = [
      'min',
      'max',
      'step',
      'data-min',
      'data-max',
      'data-cart-quantity',
      'data-inventory-quantity',
      'data-track-inventory',
      'data-continue-selling'
    ];

    attributesToUpdate.forEach((attribute) => {
      if (newQuantityInput.hasAttribute(attribute)) {
        this.input.setAttribute(
          attribute,
          newQuantityInput.getAttribute(attribute)
        );
      } else {
        this.input.removeAttribute(attribute);
      }
    });

    this.normalizeQuantityValue();

    // Reset the product quantity to its minimum when the variant changes.
    const minimumQuantity =
      parseInt(newQuantityInput.getAttribute('min'), 10) || 1;

    this.input.value = minimumQuantity;

    this.updateProductFormQuantity();
    this.validateQtyRules();
    this.restoreVariantQuantityButtons();

    requestAnimationFrame(() => {
      this.restoreVariantQuantityButtons();
    });

    setTimeout(() => {
      this.restoreVariantQuantityButtons();
    }, 100);

    const messageElement = this.parentElement.querySelector(
      '.quantity-limit-message'
    );

    if (messageElement) {
      messageElement.hidden = true;
      messageElement.textContent = '';
    }
  }

  onInputChange() {
    this.normalizeQuantityValue();
    this.validateQtyRules();
    this.updateProductFormQuantity();
  }

  restoreVariantQuantityButtons() {
    const minimum = Math.max(
      1,
      parseInt(this.input.getAttribute('min'), 10) || 1
    );
    const maximum = parseInt(
      this.input.dataset.max ?? this.input.getAttribute('max'),
      10
    );
    const currentValue = Math.max(
      minimum,
      parseInt(this.input.value, 10) || minimum
    );

    this.input.value = currentValue;

    const minusButton = this.querySelector('[name="minus"]');
    const plusButton = this.querySelector('[name="plus"]');

    if (minusButton) {
      const disableMinus = currentValue <= minimum;
      minusButton.disabled = disableMinus;
      minusButton.classList.toggle('disabled', disableMinus);
    }

    if (plusButton) {
      const disablePlus = Number.isFinite(maximum) && maximum <= 0;
      plusButton.disabled = disablePlus;
      plusButton.classList.toggle('disabled', disablePlus);

      if (!disablePlus) {
        plusButton.removeAttribute('disabled');
        plusButton.removeAttribute('aria-disabled');
      }
    }

    this.updateProductFormQuantity();
  }

  normalizeQuantityValue() {
    const minimum = Math.max(
      1,
      parseInt(this.input.getAttribute('min'), 10) || 1
    );

    const rawMaximum = parseInt(
      this.input.dataset.max ?? this.input.getAttribute('max'),
      10
    );

    if (Number.isFinite(rawMaximum) && rawMaximum <= 0) {
      // min="1" with max="0" creates an invalid number-input state.
      // Remove the real max attribute when sold out and keep the logical limit in data-max.
      this.input.removeAttribute('max');
      this.input.setAttribute('data-max', '0');
    }

    const currentValue = parseInt(this.input.value, 10);

    if (!Number.isFinite(currentValue) || currentValue < minimum) {
      this.input.value = minimum;
    }
  }

  getLimitMessageElement() {
    let messageElement = this.parentElement?.querySelector(
      '.quantity-limit-message'
    );

    if (!messageElement) {
      messageElement = document.createElement('div');
      messageElement.className = 'quantity-limit-message';
      messageElement.setAttribute('role', 'alert');
      messageElement.hidden = true;
      messageElement.style.color = '#eb001b';
      messageElement.style.fontSize = '13px';
      messageElement.style.lineHeight = '1.4';
      messageElement.style.marginTop = '8px';
      this.insertAdjacentElement('afterend', messageElement);
    }

    return messageElement;
  }

  updateProductFormQuantity() {
    const formId = this.input.getAttribute('form');

    if (!formId) return;

    const productForm = document.getElementById(formId);

    const submittedQuantity = productForm?.querySelector(
      '.product-submit-quantity'
    );

    if (submittedQuantity) {
      submittedQuantity.value = this.input.value;
    }
  }

  // old
  // onButtonClick(event) {
  //   event.preventDefault();

  //   const previousValue = this.input.value;
  //   const clickedButton = event.currentTarget;

  //   if (clickedButton.disabled) return;

  //   clickedButton.name === 'plus'
  //     ? this.input.stepUp()
  //     : this.input.stepDown();

  //   if (previousValue !== this.input.value) {
  //     this.input.dispatchEvent(this.changeEvent);
  //   }
  // }

  // New

  onButtonClick(event) {
    event.preventDefault();

    this.normalizeQuantityValue();

    const clickedButton = event.currentTarget;
    if (clickedButton.disabled) return;
    const currentValue = parseInt(this.input.value, 10) || 1;
    const maxValue = parseInt(
      this.input.dataset.max ?? this.input.getAttribute('max'),
      10
    );
    const cartQuantity = parseInt(this.input.dataset.cartQuantity, 10) || 0;
    const inventoryQuantity = parseInt(this.input.dataset.inventoryQuantity, 10) || 0;
    const messageElement = this.getLimitMessageElement();

    if (
      clickedButton.name === 'plus' &&
      Number.isFinite(maxValue) &&
      currentValue >= maxValue
    ) {
      if (messageElement) {
        if (inventoryQuantity > 0) {
          messageElement.textContent =
            `Total stock: ${inventoryQuantity}. Already in cart: ${cartQuantity}. ` +
            `You can add ${Math.max(maxValue, 0)} more.`;
        } else {
          messageElement.textContent =
            `Maximum available quantity: ${Math.max(maxValue, 0)}.`;
        }
        messageElement.hidden = false;
      }
      return;
    }

    const previousValue = this.input.value;

    clickedButton.name === 'plus'
      ? this.input.stepUp()
      : this.input.stepDown();

    if (messageElement) {
      messageElement.hidden = true;
      messageElement.textContent = '';
    }

    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }


  validateQtyRules() {
    const value = parseInt(this.input.value, 10);

    const buttonMinus = this.querySelector(
      '.quantity__button[name="minus"]'
    );

    const buttonPlus = this.querySelector(
      '.quantity__button[name="plus"]'
    );

    const min = parseInt(this.input.getAttribute('min'), 10) || 1;
    const max = parseInt(
      this.input.dataset.max ?? this.input.getAttribute('max'),
      10
    );

    if (buttonMinus) {
      const disableMinus = value <= min;

      buttonMinus.classList.toggle('disabled', disableMinus);
      buttonMinus.disabled = disableMinus;
    }

    if (buttonPlus) {
      // Keep the plus button clickable at the limit so the limit message can be shown.
      // stepUp() still prevents the quantity from exceeding the maximum.
      const disablePlus = Number.isFinite(max) && max <= 0;
      buttonPlus.classList.toggle('disabled', disablePlus);
      buttonPlus.disabled = disablePlus;
    }

  }
}



customElements.define('quantity-input', QuantityInput);


function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.querySelector('.announcement-bar-slider')) {
      this.announcementBarArrowButtonWasClicked = false;

      this.desktopLayout = window.matchMedia('(min-width: 750px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      [this.reducedMotion, this.desktopLayout].forEach((mediaQuery) => {
        mediaQuery.addEventListener('change', () => {
          if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
        });
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener('click', () => {
          this.announcementBarArrowButtonWasClicked = true;
        }, {once: true});
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked || !this.desktopLayout.matches ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked && this.desktopLayout.matches) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.querySelector('.announcement-bar-slider').contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
console.log('chnage v',this.currentVariant)
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
     // variant fix
    // Size is not chosen by the customer yet, so do not write a size-specific variant in the URL
    if (this.classList.contains('variant-fix-size-pending')) return;
    // variant fix end
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  // updateVariantStatuses() {
  //   const selectedOptionOneVariants = this.variantData.filter(
  //     (variant) => this.querySelector(':checked').value === variant.option1
  //   );
  //   const inputWrappers = [...this.querySelectorAll('.product-form__input')];
  //   inputWrappers.forEach((option, index) => {
  //     if (index === 0) return;
  //     const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
  //     const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
  //     const availableOptionInputsValue = selectedOptionOneVariants
  //       .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
  //       .map((variantOption) => variantOption[`option${index + 1}`]);
  //     this.setInputAvailability(optionInputs, availableOptionInputsValue);
  //   });
  // }

//   updateVariantStatuses() {
//   const selectedOptionOneVariants = this.variantData.filter(
//     (variant) => this.querySelector(':checked').value === variant.option1
//   );

//   const inputWrappers = [...this.querySelectorAll('.product-form__input')];

//   inputWrappers.forEach((option, index) => {
//     if (index === 0) return;

//     const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
//     const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;

//     const availableOptionInputsValue = selectedOptionOneVariants
//       .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
//       .map((variantOption) => variantOption[`option${index + 1}`]);

//     this.setInputAvailability(optionInputs, availableOptionInputsValue);

//     //Disable Options with 0 Inventory
//     const selectedOptionInput = option.querySelector('input[type="radio"]:checked');
//     const sizeVariants = this.variantData.filter(v => v['option2'] === selectedOptionInput.value);
//     sizeVariants.forEach((variant) => {
//       const sizeOption = document.querySelector(`.product-option-size_${variant['option1'].replace('/', '-')} input[type='radio']`);
//       sizeOption.classList.remove("disabled");
//       sizeOption.removeAttribute("disabled", "disabled");
//       if(!variant.available) {
//         sizeOption.classList.add("disabled");
//         sizeOption.setAttribute("disabled", "disabled");
//       }
//     });
//   });
// }
updateVariantStatuses() {
  console.log(this.variantData);
  const selectedOptionOneVariants = this.variantData.filter(
    (variant) => this.querySelector(':checked').value === variant.option1
  );

  const inputWrappers = [...this.querySelectorAll('.product-form__input')];
  const inputSizeWrapper = this.querySelector('.prodct-form__input-option--size');  

  inputWrappers.forEach((option, index) => {
    if (index === 0) return;

    const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
    const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;

    const availableOptionInputsValue = selectedOptionOneVariants
      .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
      .map((variantOption) => variantOption[`option${index + 1}`]);

    this.setInputAvailability(optionInputs, availableOptionInputsValue);

    //Disable Options with 0 Inventory
    const selectedOptionInput = option.querySelector('input[type="radio"]:checked');
    const sizeVariants = this.variantData.filter(v => v['option2'].toLowerCase() === selectedOptionInput.value.toLowerCase());
    console.log(sizeVariants);
    sizeVariants.forEach((variant) => {
      let sizeOption = document.querySelector(`.product-option-size_${variant['option1'].replace('/', '-')} input[type='radio']`);
      if(inputSizeWrapper){
       sizeOption = inputSizeWrapper.querySelector(`.product-option-size_${variant['option1'].replace('/', '-')} input[type='radio']`);
      } 
      sizeOption.classList.remove("disabled");
      sizeOption.removeAttribute("disabled", "disabled");
      if(!variant.available) {
        sizeOption.classList.add("disabled");
        sizeOption.setAttribute("disabled", "disabled");
      }
    });
  });
}
  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;
console.log('chekc')
    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
          document.querySelectorAll('.grid__item').forEach(productCard => {
            const sliderCard = productCard.querySelector('.product-card-slide-swiper')
            let px = new Swiper(sliderCard, {
              loop: true,
              autoHeight: true,
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
              }
            });

            productCard.querySelectorAll('.input-field-Color').forEach( el => {
              el.addEventListener('click', () => {
                productCard.querySelectorAll('.product_card_media_box').forEach(mediaBox => {
                  let Img = mediaBox.querySelector('img')
                  if (Img.getAttribute('alt') === el.dataset.variantValue) {
                    px.slideToLoop(parseInt(mediaBox.dataset.swiperSlideIndex));
                  }
                });
              });
            });
          });
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


// popup
document.addEventListener('DOMContentLoaded', function() {
  var popupButtons = document.querySelectorAll('.popup'); // get ALL buttons

  popupButtons.forEach(function(popupButton) {
    popupButton.addEventListener('click', function(event) {
      event.preventDefault();

      // Create the popup content
      var popupContent = document.createElement('div');
      popupContent.classList.add('popup-content');
      popupContent.innerHTML = `
        <div class="popup-overlay"></div>
        <div class="popup-inner">
          <h2>Contact for Bulk Orders</h2>
          <h3>Call: +92 42 32761236</h3>
          <h3>Email: bataindustrials.pk@bata.com<br>asim.mahmood@bata.com</h3>
          <button class="popup-close">Close</button>
        </div>
      `;
      document.body.appendChild(popupContent);

      // Add event listener to close the popup
      var closeButton = popupContent.querySelector('.popup-close');
      var overlay = popupContent.querySelector('.popup-overlay');

      function closePopup() {
        document.body.removeChild(popupContent);
      }

      closeButton.addEventListener('click', closePopup);
      overlay.addEventListener('click', closePopup);
    });
  });
});


function resetProductQuantitySelectors() {
  document
    .querySelectorAll(
      'product-info .quantity__input[name="quantity_display"], ' +
      'product-info .quantity__input[id^="Quantity-"]'
    )
    .forEach((quantityInput) => {
      const minimum =
        parseInt(quantityInput.getAttribute('min'), 10) || 1;

      let maximum = parseInt(
        quantityInput.dataset.max ?? quantityInput.getAttribute('max'),
        10
      );

      // Normalize a zero or negative logical maximum without creating min/max conflicts.
      if (Number.isFinite(maximum) && maximum <= 0) {
        maximum = 0;
        quantityInput.removeAttribute('max');
        quantityInput.dataset.max = '0';
      }

      // Product-page selector hamesha 1 se start hoga
      quantityInput.value = minimum;

      const formId = quantityInput.getAttribute('form');
      const productForm = formId
        ? document.getElementById(formId)
        : null;

      const hiddenQuantity = productForm?.querySelector(
        '.product-submit-quantity'
      );

      if (hiddenQuantity) {
        hiddenQuantity.value = minimum;
      }

      const quantityComponent =
        quantityInput.closest('quantity-input');

      const minusButton = quantityComponent?.querySelector(
        '[name="minus"]'
      );

      const plusButton = quantityComponent?.querySelector(
        '[name="plus"]'
      );

      if (minusButton) {
        minusButton.disabled = true;
        minusButton.classList.add('disabled');
      }

      if (
        plusButton &&
        Number.isFinite(maximum) &&
        maximum <= 0
      ) {
        plusButton.disabled = true;
        plusButton.classList.add('disabled');
      }

      quantityInput.dispatchEvent(
        new Event('change', { bubbles: true })
      );
    });
}

// Allow cart.js to reset only the PDP selector after a successful add.
// Cart drawer quantity inputs are intentionally excluded.
window.resetProductQuantitySelectors = resetProductQuantitySelectors;

async function syncProductPageQuantityWithCart() {
  const productQuantityInputs = document.querySelectorAll(
    'product-info .quantity__input[name="quantity_display"], ' +
    'product-info .quantity__input[id^="Quantity-"]'
  );

  if (!productQuantityInputs.length) return;

  try {
    const response = await fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) return;

    const cart = await response.json();

    productQuantityInputs.forEach((quantityInput) => {
      const formId = quantityInput.getAttribute('form');
      const productForm = formId
        ? document.getElementById(formId)
        : quantityInput.closest('product-info')?.querySelector(
            'form[data-type="add-to-cart-form"]'
          );

      if (!productForm) return;

      const variantId = Number(
        productForm.querySelector('[name="id"]')?.value
      );

      if (!variantId) return;

      const cartQuantity = cart.items
        .filter((item) => Number(item.variant_id) === variantId)
        .reduce((total, item) => total + item.quantity, 0);

      const inventoryQuantity = Number(
        quantityInput.dataset.inventoryQuantity
      );
      const tracksInventory =
        quantityInput.dataset.trackInventory === 'true';
      const continueSelling =
        quantityInput.dataset.continueSelling === 'true';

      quantityInput.dataset.cartQuantity = cartQuantity;
      quantityInput.value = '1';

      const hiddenQuantity = productForm.querySelector(
        '.product-submit-quantity, [name="quantity"]'
      );

      if (hiddenQuantity) hiddenQuantity.value = '1';

      let soldOut = false;

      if (
        tracksInventory &&
        !continueSelling &&
        Number.isFinite(inventoryQuantity)
      ) {
        const remainingQuantity = Math.max(
          inventoryQuantity - cartQuantity,
          0
        );

        quantityInput.dataset.max = remainingQuantity;

        if (remainingQuantity > 0) {
          quantityInput.setAttribute('max', remainingQuantity);
        } else {
          quantityInput.removeAttribute('max');
          soldOut = true;
        }
      }

      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = addButton?.querySelector('span');

      if (addButton) {
        addButton.disabled = soldOut;

        if (soldOut) {
          addButton.setAttribute('disabled', 'disabled');
        } else {
          addButton.removeAttribute('disabled');
        }
      }

      if (addButtonText) {
        addButtonText.textContent = soldOut
          ? window.variantStrings?.soldOut || 'SOLD OUT'
          : window.variantStrings?.addToCart || 'ADD TO CART';
      }

      const quantityComponent = quantityInput.closest('quantity-input');
      const minusButton = quantityComponent?.querySelector('[name="minus"]');
      const plusButton = quantityComponent?.querySelector('[name="plus"]');

      // Always start the PDP selector at 1 after a cart update.
      if (minusButton) {
        minusButton.disabled = true;
        minusButton.classList.add('disabled');
      }

      // Restore the plus button when inventory becomes available again.
      if (plusButton) {
        plusButton.disabled = soldOut;
        plusButton.classList.toggle('disabled', soldOut);
        plusButton.removeAttribute('aria-disabled');
      }

      const quantityLabel = quantityInput
        .closest('.product-form__quantity')
        ?.querySelector('.quantity__rules-cart');

      if (quantityLabel) {
        quantityLabel.classList.toggle('hidden', cartQuantity === 0);

        const textElement = quantityLabel.querySelector(
          ':scope > span:last-child'
        );

        if (textElement) {
          textElement.textContent = `(${cartQuantity} in cart)`;
        }
      }

      quantityInput.dispatchEvent(
        new Event('change', { bubbles: true })
      );
    });
  } catch (error) {
    console.error('Unable to sync product quantity with cart:', error);
  }
}

window.syncProductPageQuantityWithCart = syncProductPageQuantityWithCart;

// Recalculate the remaining quantity on refresh or direct page load.
// Example: stock 25, cart 23 => maximum additional quantity 2.
document.addEventListener('DOMContentLoaded', () => {
  syncProductPageQuantityWithCart();
  setTimeout(syncProductPageQuantityWithCart, 150);
});

window.addEventListener('pageshow', () => {
  syncProductPageQuantityWithCart();
  setTimeout(syncProductPageQuantityWithCart, 150);
});

if (typeof subscribe === 'function' && PUB_SUB_EVENTS?.cartUpdate) {
  subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
    syncProductPageQuantityWithCart();
    setTimeout(syncProductPageQuantityWithCart, 150);
  });
}

function preventNegativeProductQuantities() {
  document
    .querySelectorAll(
      'product-info .quantity__input[name="quantity_display"], ' +
      'product-info .quantity__input[id^="Quantity-"]'
    )
    .forEach((quantityInput) => {
      const currentValue = parseInt(quantityInput.value, 10);
      const logicalMaximum = parseInt(
        quantityInput.dataset.max ?? quantityInput.getAttribute('max'),
        10
      );

      if (Number.isFinite(logicalMaximum) && logicalMaximum <= 0) {
        if (quantityInput.dataset.max !== '0') {
          quantityInput.dataset.max = '0';
        }
        if (quantityInput.hasAttribute('max')) {
          quantityInput.removeAttribute('max');
        }
      }

      if (!Number.isFinite(currentValue) || currentValue < 1) {
        quantityInput.value = '1';

        const formId = quantityInput.getAttribute('form');
        const productForm = formId
          ? document.getElementById(formId)
          : null;
        const hiddenQuantity = productForm?.querySelector(
          '.product-submit-quantity, [name="quantity"]'
        );

        if (hiddenQuantity) hiddenQuantity.value = '1';
      }

      const quantityComponent = quantityInput.closest('quantity-input');
      const minusButton = quantityComponent?.querySelector('[name="minus"]');
      const plusButton = quantityComponent?.querySelector('[name="plus"]');

      if (minusButton && Number(quantityInput.value) <= 1) {
        minusButton.disabled = true;
        minusButton.classList.add('disabled');
      }

      if (plusButton && logicalMaximum <= 0) {
        plusButton.disabled = true;
        plusButton.classList.add('disabled');
      }
    });
}

window.preventNegativeProductQuantities = preventNegativeProductQuantities;

document.addEventListener('DOMContentLoaded', preventNegativeProductQuantities);
window.addEventListener('pageshow', () => {
  preventNegativeProductQuantities();
  setTimeout(preventNegativeProductQuantities, 100);
});

document.addEventListener('click', (event) => {
  if (
    event.target instanceof Element &&
    event.target.closest('quantity-input, [name="add"]')
  ) {
    setTimeout(preventNegativeProductQuantities, 0);
    setTimeout(preventNegativeProductQuantities, 100);
  }
});

const productQuantityObserver = new MutationObserver(() => {
  preventNegativeProductQuantities();
});

const productInfoForQuantityGuard = document.querySelector('product-info');

if (productInfoForQuantityGuard) {
  productQuantityObserver.observe(productInfoForQuantityGuard, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['value', 'max', 'data-max']
  });
}

// Use event delegation so PDP quantity buttons continue working after
// Shopify replaces variant-related HTML.
document.addEventListener(
  'click',
  (event) => {
    if (!(event.target instanceof Element)) return;

    const button = event.target.closest(
      'quantity-input .quantity__button[name="plus"], ' +
      'quantity-input .quantity__button[name="minus"]'
    );

    if (!button) return;

    const quantityComponent = button.closest('quantity-input');
    const input = quantityComponent?.querySelector(
      '.quantity__input[name="quantity_display"], ' +
      '.quantity__input[id^="Quantity-"]'
    );

    // Do not interfere with cart drawer or cart page quantity controls.
    if (
      !quantityComponent ||
      !input ||
      quantityComponent.closest(
        '.cart-item, cart-drawer, cart-items, cart-drawer-items'
      )
    ) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    const minimum = Math.max(
      1,
      parseInt(input.getAttribute('min'), 10) || 1
    );
    const step = Math.max(
      1,
      parseInt(input.getAttribute('step'), 10) || 1
    );
    const maximum = parseInt(
      input.dataset.max ?? input.getAttribute('max'),
      10
    );
    const currentValue = Math.max(
      minimum,
      parseInt(input.value, 10) || minimum
    );

    let nextValue = currentValue;

    if (button.name === 'plus') {
      if (Number.isFinite(maximum) && currentValue >= maximum) {
        const inventoryQuantity =
          parseInt(input.dataset.inventoryQuantity, 10) || 0;
        const cartQuantity =
          parseInt(input.dataset.cartQuantity, 10) || 0;
        const messageElement =
          quantityComponent.getLimitMessageElement?.();

        if (messageElement) {
          messageElement.textContent = inventoryQuantity > 0
            // ? `Total stock: ${inventoryQuantity}. Already in cart: ${cartQuantity}. ` +
            //   `You can add ${Math.max(maximum, 0)} more.`
            // : `Maximum available quantity: ${Math.max(maximum, 0)}.`;

            const availableToAdd = Math.max(maximum, 0);

            messageElement.textContent =
              `Only ${availableToAdd} item${availableToAdd === 1 ? '' : 's'} ` +
              `can be added due to availability.`;
          messageElement.hidden = false;
        }

        return;
      }

      nextValue = Number.isFinite(maximum)
        ? Math.min(currentValue + step, maximum)
        : currentValue + step;
    } else {
      nextValue = Math.max(currentValue - step, minimum);
    }

    input.value = nextValue;
    input.dispatchEvent(new Event('change', { bubbles: true }));

    const messageElement = quantityComponent.querySelector(
      '.quantity-limit-message'
    ) || quantityComponent.parentElement?.querySelector(
      '.quantity-limit-message'
    );

    if (messageElement && button.name === 'minus') {
      messageElement.hidden = true;
      messageElement.textContent = '';
    }
  },
  true
);

// Normal page load
document.addEventListener(
  'DOMContentLoaded',
  resetProductQuantitySelectors
);

// Browser back button/BFCache return
window.addEventListener('pageshow', function () {
  resetProductQuantitySelectors();
  setTimeout(resetProductQuantitySelectors, 0);
  setTimeout(resetProductQuantitySelectors, 150);
});

// variant fix
/*
 * Product page variant picker fixes:
 *  1. Show the selected color name next to the "Color" label.
 *  2. Size is NOT selected by default (the picker gets the class
 *     "variant-fix-size-pending" from snippets/product-variant-picker.liquid).
 *     The first available size stays checked internally so the existing price /
 *     media / availability code keeps working, but it looks unselected.
 *  3. Add to cart without choosing a size shows "Please select a size".
 */
(function () {
  var PENDING_SELECTOR = 'variant-radios.variant-fix-size-pending';

  function getPendingPicker(sectionId) {
    return document.querySelector(PENDING_SELECTOR + '[data-section="' + sectionId + '"]');
  }

  // 1. Selected color name next to the "Color" label
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('variant-radios input[type="radio"]')) return;

    var fieldset = input.closest('fieldset');
    var colorName = fieldset && fieldset.querySelector('.variant-fix-color-name');
    if (colorName) colorName.textContent = ': ' + input.value;
  });

  // 2. Customer clicked a size: it is now a real selection
  document.addEventListener('click', function (event) {
    var sizeValue = event.target.closest && event.target.closest(PENDING_SELECTOR + ' .product-option-size--value');
    if (!sizeValue) return;

    var input = sizeValue.querySelector('input[type="radio"]');
    if (input && input.disabled) return;

    var picker = sizeValue.closest('variant-radios');
    picker.classList.remove('variant-fix-size-pending');

    var error = picker.querySelector('.variant-fix-size-error');
    if (error) error.hidden = true;
  });

  // 3. Block add to cart until a size is selected (capture phase = runs before cart.js)
  document.addEventListener(
    'click',
    function (event) {
      var button =
        event.target.closest &&
        event.target.closest('[data-add-to-cart], .add-to-cart, .product-form__submit');
      if (!button || button.classList.contains('popup')) return;

      var form = button.closest('form');
      // form.id would return the <input name="id"> element, so read the attribute
      var formId = form && form.getAttribute('id');
      if (!formId) return;

      var sectionId = formId.replace(/^product-form-(installment-)?/, '');
      var picker = getPendingPicker(sectionId);
      if (!picker) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var error = picker.querySelector('.variant-fix-size-error');
      if (error) error.hidden = false;
    },
    true
  );

  // While no size is chosen, a sold-out size that is only checked internally must not
  // disable the button: keep it enabled if the selected color has any size available.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var sectionId = event && event.data && event.data.sectionId;
      var picker = sectionId && getPendingPicker(sectionId);
      if (!picker || typeof picker.getVariantData !== 'function') return;

      var fieldsets = Array.prototype.slice.call(picker.querySelectorAll('fieldset'));
      var colorIndex = -1;
      fieldsets.forEach(function (fieldset, index) {
        if (fieldset.querySelector('.variant-fix-color-name')) colorIndex = index;
      });

      var colorValue = null;
      if (colorIndex > -1) {
        var checkedColor = fieldsets[colorIndex].querySelector('input:checked');
        colorValue = checkedColor && checkedColor.value;
      }

      var hasAvailableSize = picker.getVariantData().some(function (variant) {
        return variant.available && (colorIndex === -1 || variant.options[colorIndex] === colorValue);
      });

      if (hasAvailableSize) picker.toggleAddButton(false);
    });
  }
})();
// variant fix end